import {ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {
  ApexChart,
  ChartComponent,
  ApexDataLabels,
  ApexPlotOptions,
  ApexLegend,
  ApexStroke,
  ApexTooltip,
  ApexAxisChartSeries,
  ApexFill,
  ApexXAxis,
  ApexGrid
} from 'ng-apexcharts';
import {FormControl, FormGroup} from "@angular/forms";
import {TranslateService} from "../../../../../shared/services/translate.service";
import {SchoolProgramService} from "../../../../../shared/services/school-program.service";
import {SchoolProgramActivityModel} from "../../../../../shared/models/school-program-activity-model";


export interface activityParticipant {
  series: ApexAxisChartSeries;
  dataLabels: ApexDataLabels;
  chart: ApexChart;
  legend: ApexLegend;
  xaxis: ApexXAxis;
  grid: ApexGrid;
  stroke: ApexStroke;
  plotOptions: ApexPlotOptions;
  fill: ApexFill;
  tooltip: ApexTooltip;
}


@Component({
  selector: 'app-participant-graph',
  templateUrl: './participant-graph.component.html',
  styleUrls: ['./participant-graph.component.scss'],

})
export class ParticipantGraphComponent implements OnInit, OnChanges{

  @ViewChild("activeusercardchart") chart1: ChartComponent = Object.create(null);
  public activityParticipant !: Partial<activityParticipant> | any;

  @Input()
  academic_year: any = null;

  constructor(
      private translate: TranslateService,
      private cd: ChangeDetectorRef,
      private schoolProgramService: SchoolProgramService) {

    translate.load('extracurricular');
    // active users
    this.activityParticipant = {

      chart: {
        toolbar: {
          show: false,
        },
        type: 'bar',
        height: 300,

      },
      legend: {
        show: false,
      },

      tooltip: {
        theme: "dark"
      },

      grid: {
        show: true,
      },

      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 5,
        colors: ['none']
      },
    }
  }
  paramForm: FormGroup;
  selectedSchoolLevel = null;
  dataActivity = [];
  hasData: boolean = false;
  task = null;
  loading = false;

  ngOnInit() {
    this.initForm();
  }
  initForm() {
    this.paramForm = new FormGroup({
      'name': new FormControl(null),
      'academic_year': new FormControl(this.academic_year),
      'period_id': new FormControl(null),
      'school_location_id': new FormControl(null),
      'school_level_id': new FormControl(null),
      'year_level_id': new FormControl(null),
      'school_level_relation_id': new FormControl(null),
      'school_program_id': new FormControl(null)
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['academic_year'] && !changes['academic_year'].firstChange) {
      this.resetSchoolLocation();
    }
  }

  resetSchoolLocation() {
    this.paramForm.controls['school_location_id'].setValue(null);
  }

  onChangeSchoolLevelRelation(item: any) {
    this.paramForm.controls['school_location_id'].markAsTouched();
    this.paramForm.controls['school_location_id'].setValue(item ? item.school_location_id : null);

    this.paramForm.controls['school_level_id'].markAsTouched();
    this.paramForm.controls['school_level_id'].setValue(item ? item.school_level_id : null);

    this.selectedSchoolLevel = item ? item.school_level_id : null;

    this.paramForm.controls['school_program_id'].setValue(null);
    this.hasData = false;

  }

  onChangeSchoolProgram(item: any) {
    this.paramForm.controls['school_program_id'].markAsTouched();
    this.paramForm.controls['school_program_id'].setValue(item ? item.school_program_id : null);

    if (item) {
      this.getFilteredactivity();
    }
  }

  getFilteredactivity() {
    this.loading = true;
    this.hasData = false;
    const data = this.paramForm.value;
    data.academic_year = this.academic_year;
    this.schoolProgramService.getSchoolProgramParticipantChart(
     data
    ).subscribe(
        (response: SchoolProgramActivityModel[]) => {
          // @ts-ignore
          if (response['status']) {
            // @ts-ignore
            this.dataActivity = response['data'].slice();
            this.hasData = this.dataActivity.length > 0;
            const participantAmount = this.dataActivity.map((i: any) => i.total);
            const ActivityName = this.dataActivity.map((i: any) => i.activity_name);

              this.activityParticipant.series = [
                {
                  name: 'Participant Amount',
                  data: participantAmount,
                }
              ];
              this.activityParticipant.xaxis = {
                categories: ActivityName,
              };

            this.activityParticipant.plotOptions = {
              bar: {
                columnWidth: '45%',
                    borderRadius: 5,
                    distributed: true,
              },
            };

            this.loading = false;
          } else {
            this.loading = false;
          }
        },
        (error) => {
          this.loading = false;
        }
    );
  }
}
